import { ReactComponent as Youtube } from 'assets/icons/icon-youtube.svg';

export default Youtube;
